// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"styles_modalFooter___LGKG","footerButton":"styles_footerButton__XEutA"};